import { darkThemeColors } from '../../tokens/dark-colors';
import { baseTheme } from '../base-theme';
import { ThemeNames } from '../theme.types';
import { popover, spinner, button, menu, tag, nav, drawer, backdrop, modal, checkbox, radio, notificationBanner, notification, input, textarea, tabs, toggle, table, severityTag, buttonGroup, } from '../../tokens';
import { darkShadow } from '../../tokens/dark-shadow';
import { select } from '../../tokens/component/select';
import { shadowScroll } from '../../tokens/component/shadow-scroll';
import { dates } from '../../tokens/component/dates';
const baseDarkTheme = {
    ...baseTheme,
    name: ThemeNames.Dark,
    colors: darkThemeColors,
    shadows: darkShadow,
};
export const darkTheme = {
    ...baseDarkTheme,
    button: button(baseDarkTheme),
    notificationBanner: notificationBanner(baseDarkTheme),
    notification: notification(baseDarkTheme),
    popover: popover(baseDarkTheme),
    menu: menu(baseDarkTheme),
    tag: tag(baseDarkTheme),
    nav: nav(baseDarkTheme),
    spinner,
    drawer: drawer(baseDarkTheme),
    backdrop: backdrop(baseDarkTheme),
    modal: modal(baseDarkTheme),
    checkbox: checkbox(baseDarkTheme),
    radio: radio(baseDarkTheme),
    tabs: tabs(baseDarkTheme),
    select: select(baseDarkTheme),
    input: input(baseDarkTheme),
    textarea: textarea(baseDarkTheme),
    toggle: toggle(baseDarkTheme),
    shadowScroll: shadowScroll(baseDarkTheme),
    datePicker: dates(baseDarkTheme),
    table: table(baseDarkTheme),
    severityTag: severityTag(baseDarkTheme),
    buttonGroup: buttonGroup(baseDarkTheme),
};
//# sourceMappingURL=dark-theme.js.map